import React, { createContext, useContext, useState } from "react";
import { toast } from "react-toastify";
import { fetchOnboardingTableAndFilterSchema } from "model/OnboardingModel";
import { useCommonFilterOptions } from "./CommonFilterOptionsContext";

const OnboardingContext = createContext();

export const OnboardingProvider = ({ children }) => {
  const { fetchMetadataSchema } = useCommonFilterOptions();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [onboardingContextData, setOnboardingContextData] = useState();

  const fetchOnboardingContextData = async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await fetchMetadataSchema("metadata:onboarding", () =>
        fetchOnboardingTableAndFilterSchema([])
      );
      if (response?.success) {
        setOnboardingContextData(response?.data);
      } else {
        setError(response?.message || "Unable to fetch onboarding metadata");
      }
    } catch (err) {
      toast.error(err?.message || "Something went wrong");
      setError(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <OnboardingContext.Provider
      value={{
        fetchOnboardingContextData,
        onboardingContextData,
        loading,
        error,
      }}
    >
      {children}
    </OnboardingContext.Provider>
  );
};

export const useOnboardingContext = () => useContext(OnboardingContext);
